export const validarElegibilidadeExame = ({
    graduacao,
    exame,
    nome,
    aluno
}) => {

    if (!exame) {
        return { permitido: false, mensagem: "Exame inválido" };
    }

    const faixasExame = exame.faixas || [];

    // 🔹 Se não possui graduação
    if (!graduacao) {

        const faixaInicial = faixasExame.find(f => f.id === 1);

        if (!faixaInicial) {
            return {
                permitido: false,
                mensagem: "Graduação indisponível no momento"
            };
        }

        // 🔹 Regra idade para faixa 1
        if (aluno?.idadeFimAno < (faixaInicial.carenciaIdade || 0)) {
            return {
                permitido: false,
                mensagem: `Olá ${nome}, você ainda não obteve todos os critérios de carência para realização do exame`
            };
        }

        return { permitido: true, mensagem: null };
    }

    // 🔹 Próxima faixa obrigatória
    const proximaFaixaId = graduacao.id + 1;

    const faixaDisponivel = faixasExame.find(f => f.id === proximaFaixaId);

    if (!faixaDisponivel) {
        return {
            permitido: false,
            mensagem: "Graduação indisponível no momento"
        };
    }

    // 🔹 Validação carência dias
    const dataCadastro = new Date(graduacao.dataCadastro);
    const dataExame = new Date(exame.data);

    const dataLiberacao = new Date(dataCadastro);
    dataLiberacao.setDate(
        dataLiberacao.getDate() + (graduacao.carenciaDias || 0)
    );

    if (dataLiberacao >= dataExame) {
        return {
            permitido: false,
            mensagem: `Olá ${nome}, você não está apto para a realização do exame`
        };
    }

    // 🔹 NOVA REGRA - Carência de idade
    if (aluno?.idadeFimAno < (faixaDisponivel.carenciaIdade || 0)) {
        return {
            permitido: false,
            mensagem: `Olá ${nome}, você ainda não obteve todos os critérios de carência para realização do exame`
        };
    }

    return { permitido: true, mensagem: null };
};